 
class GtmTracking {
    /**
     * =================================================================================================================
     * GTM
     * =================================================================================================================
     */
    trackOnlineRegistration(registration_type, from, course_name, transaction_id, contact_id, value, user_gender, user_birth_date, ecp_code, entrance_type, email, phone_number, first_name, last_name, city) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: 'online_registration',
            registration_type: registration_type ?? '',
            from: from ?? '',
            course_name: course_name ?? '',
            transaction_id: transaction_id ?? '',
            contact_id: contact_id ?? '',
            value: value ?? 0,
            currency: 'EUR',
            user_gender: user_gender ?? '',
            user_birth_date: user_birth_date ?? '',
            ecp_code: ecp_code ?? '',
            entrance_type: entrance_type ?? '',

            user_data: {
                email: email ?? '',
                phone_number: phone_number ?? '',
                address: {
                    first_name: first_name ?? '',
                    last_name: last_name ?? '',
                    city: city ?? '',
                }
            }
        });

        console.log('online_registration tracked:', {
            event: 'online_registration',
            registration_type,
            course_name,
            transaction_id,
            contact_id,
            value,
            currency: 'EUR',
            user_gender,
            user_birth_date,
            ecp_code,
            entrance_type,
            email,
            phone_number,
            first_name,
            last_name,
            city,
        });
    }
}

export default GtmTracking;  